var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { "my-4": !_vm.isReadOnly } }, [
    !_vm.isReadOnly
      ? _c("div", { staticClass: "row pl-4" }, [
          _c(
            "div",
            { staticClass: "col-md-10" },
            [
              _c(
                "validation-observer",
                { ref: "observer", attrs: { novalidate: "" } },
                [
                  _c("div", { staticClass: "row" }, [
                    _vm.showIntervation
                      ? _c(
                          "div",
                          { staticClass: "col-12 col-md-6" },
                          [
                            _c("div", { staticClass: "data-name" }, [
                              _vm._v(" Intervención: ")
                            ]),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Favor de seleccionar la interveción recomendada. (0023)",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            options: _vm.catalog.interventions,
                                            placeholder: "Seleccione"
                                          },
                                          on: {
                                            input: _vm.onChangeIntervention
                                          },
                                          model: {
                                            value: _vm.model.intervention,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "intervention",
                                                $$v
                                              )
                                            },
                                            expression: "model.intervention"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3598078563
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showFrequency
                      ? _c(
                          "div",
                          { staticClass: "col-12 col-md-6" },
                          [
                            _c("div", { staticClass: "data-name" }, [
                              _vm._v(" Frecuencia: ")
                            ]),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Favor de seleccionar la frecuencia recomendada. (0208)",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            options: _vm.catalog.frequencies,
                                            placeholder: "Seleccione"
                                          },
                                          model: {
                                            value: _vm.model.frecuency,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "frecuency",
                                                $$v
                                              )
                                            },
                                            expression: "model.frecuency"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1679741047
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showModalities
                      ? _c(
                          "div",
                          { staticClass: "col-12 col-md-6 my-3" },
                          [
                            _c("div", { staticClass: "data-name" }, [
                              _vm._v("Modalidad:")
                            ]),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Favor de seleccionar la modalidad recomendada. (0210)",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            options: _vm.catalog.modalities,
                                            placeholder: "Seleccione"
                                          },
                                          model: {
                                            value: _vm.model.modality,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "modality",
                                                $$v
                                              )
                                            },
                                            expression: "model.modality"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                405017256
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showDurations
                      ? _c(
                          "div",
                          { staticClass: "col-12 col-md-6 my-3" },
                          [
                            _c("div", { staticClass: "data-name" }, [
                              _vm._v("Duración:")
                            ]),
                            _vm.canShowDuration
                              ? _c("validation-provider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-drop-down", {
                                              attrs: {
                                                "custom-error-msg":
                                                  "Favor de seleccionar la duración recomendada. (0207)",
                                                error: errors[0],
                                                fieldkey: "id",
                                                fieldname: "name",
                                                options: _vm.durationsOptions,
                                                placeholder: "Seleccione"
                                              },
                                              model: {
                                                value: _vm.model.duration,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "duration",
                                                    $$v
                                                  )
                                                },
                                                expression: "model.duration"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3222062336
                                  )
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-md-2 d-flex align-items-end justify-content-end"
            },
            [
              _c(
                "action-button",
                {
                  attrs: { i: "fa fa-file-plus", variant: "success" },
                  on: { click: _vm.addServiceHandler }
                },
                [_vm._v(" Añadir ")]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.interventions.length
      ? _c(
          "div",
          { staticClass: "mx-3", class: { "mt-5": !_vm.isReadOnly } },
          _vm._l(_vm.interventions, function(item, index) {
            return _c(
              "div",
              {
                key: `intevention-${index}`,
                staticClass: "row bg-secondary-3 p-3 mb-3"
              },
              [
                _vm.showIntervation
                  ? _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v(" Tipo de Servicio: ")
                      ]),
                      _c("div", [
                        _vm._v(
                          " " + _vm._s(item.analysisServiceDescription) + " "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm.showModalities
                  ? _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v(" Modalidad: ")
                      ]),
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(item.analysisServiceModalityDescription) +
                            " "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm.showFrequency
                  ? _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v(" Frecuencia: ")
                      ]),
                      _c("div", [
                        _vm._v(" " + _vm._s(item.frequencyDescription) + " ")
                      ])
                    ])
                  : _vm._e(),
                _vm.showDurations
                  ? _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v(" Duración: ")
                      ]),
                      _c("div", [
                        _vm._v(" " + _vm._s(item.durationDescription) + " ")
                      ])
                    ])
                  : _vm._e(),
                !_vm.isReadOnly
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col text-right d-flex justify-content-center align-items-center"
                      },
                      [
                        _c(
                          "action-button",
                          {
                            attrs: {
                              i: "fa fa-times-circle",
                              variant: "outline-danger"
                            },
                            on: {
                              click: function($event) {
                                return _vm.deleteServiceHandler(index)
                              }
                            }
                          },
                          [_vm._v(" Eliminar ")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }